import { lazy } from 'react';

const AbandonedCartContent = import(
  'components/abandoned-cart/components/AbandonedCart/AbandonedCartContent'
  );

export const AbandonedCart = {
  Content: lazy(() => AbandonedCartContent)
};

export default AbandonedCart;